import { isEmpty } from "lodash/fp";

import Typography from "@mui/material/Typography";

import CategoryAccordion from "@app/analytics/components/CategoryAccordion";
import type { RecommendationCategoryType } from "@app/analytics/Recommendations/types";
import type { Recommendation } from "@app/analytics/types";
import * as RecommendationUtils from "@app/analytics/utils/recommendationUtils";

import { Row } from "@rui/Stack";

import {
  RECOMMENDATION_CATEGORY_PROPS,
  Chip,
  RecommendationCategoryItemContainer,
} from "./styles";
import RecommendationActionIcon from "../RecommendationActionIcon";

interface RecommendationCategoryProps {
  category: RecommendationCategoryType;
  onClick: () => void;
  recommendations: Recommendation[];
}

const RecommendationCategoryItem = ({
  onClick,
  recommendation,
}: {
  onClick: RecommendationCategoryProps["onClick"];
  recommendation: Recommendation;
}) => {
  const defaultAction = RecommendationUtils.getDefaultAction(recommendation);

  return (
    <RecommendationCategoryItemContainer spacing={0.5} onClick={onClick}>
      <Typography variant="bodyPrimaryReg">
        {recommendation.meetingContext.title}
      </Typography>
      <Row spacing={1} variant="left">
        <RecommendationActionIcon recommendation={recommendation} />
        <Typography variant="labelReg">{defaultAction.label}</Typography>
      </Row>
    </RecommendationCategoryItemContainer>
  );
};

const RecommendationCategory = ({
  category,
  onClick,
  recommendations,
}: RecommendationCategoryProps) => {
  if (isEmpty(recommendations)) return null;

  const { title, icon, color } = RECOMMENDATION_CATEGORY_PROPS[category];

  return (
    <CategoryAccordion
      label={title}
      endIcon={
        <Chip sx={{ bgcolor: color }}>
          {icon} <span>{recommendations.length}</span>
        </Chip>
      }
    >
      {recommendations.map((rec) => (
        <RecommendationCategoryItem
          key={rec.id}
          onClick={onClick}
          recommendation={rec}
        />
      ))}
    </CategoryAccordion>
  );
};

export default RecommendationCategory;
